import { render, staticRenderFns } from "./ModeSwitch2.vue?vue&type=template&id=01bba7f0&scoped=true&lang=pug&"
import script from "./ModeSwitch2.vue?vue&type=script&lang=js&"
export * from "./ModeSwitch2.vue?vue&type=script&lang=js&"
import style0 from "./ModeSwitch2.vue?vue&type=style&index=0&id=01bba7f0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bba7f0",
  null
  
)

export default component.exports